export enum FlowStorageResumeType {
    NONE = "none",
    CLIENT = "client",
    SERVER = "server",
}
